import { ButtonLink } from '@/components/Button'

import { HeadingL } from '@/components/Typography'

import { Carousel } from './Carousel'

import { MediaWithCarouselContainer } from './styles'
import type { MediaCarouselProps } from './types'

const MediaWithCarousel = ({ title, cta, items }: MediaCarouselProps) => (
  <MediaWithCarouselContainer
    backgroundColor="custom"
    backgroundColorHex="#000"
    spaceOut="0"
    spaceIn="0"
    contentClassName="media-with-carousel__content"
  >
    {!!title && (
      <HeadingL light="solid" tag="h2" className="media-with-carousel__title">
        {title}
      </HeadingL>
    )}
    {items && items.length && <Carousel slides={items} />}
    {cta && (
      <ButtonLink
        className="media-with-carousel__cta-btn"
        rounded
        size="md"
        modifier="solid"
        source={cta.href}
        aria-label={cta.ariaLabel}
      >
        {cta.label}
      </ButtonLink>
    )}
  </MediaWithCarouselContainer>
)

export default MediaWithCarousel
